import { get, post, put, del } from '../rest';

export default {
  getAnswerTypes: () => get('/admin/answer_types'),
  createAnswerType: params => post('/admin/answer_types', params),
  updateAnswerType: (id, params) => put('/admin/answer_types/' + id, params),
  deleteAnswerType: id => del('/admin/answer_types/' + id),
};
